import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateBeneficiaryDetails } from '../services/fn-api/Beneficiary';
import { BENEFICIARY_KEY, USER_KEY } from 'src/utils/constants/queryKeys';

export const useUpdateBeneficiaryDetails = () => {
  const queryClient = useQueryClient();

  return useMutation<Record<string, unknown>, Error, Record<string, unknown>>({
    mutationFn: async (data: Record<string, unknown>) => {
      return updateBeneficiaryDetails(data);
    },
    onSuccess: (response) => {
      queryClient.setQueryData([BENEFICIARY_KEY, response.beneId], response);
      queryClient.refetchQueries({ queryKey: [USER_KEY] });
    },
  });
};
